import { render } from "./ResourceAssociator.vue?vue&type=template&id=4d9a70f0&scoped=true"
import script from "./ResourceAssociator.vue?vue&type=script&lang=js"
export * from "./ResourceAssociator.vue?vue&type=script&lang=js"

import "./ResourceAssociator.vue?vue&type=style&index=0&id=4d9a70f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9a70f0"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBanner,QList,QItem,QItemSection,QBadge,QIcon});
